export enum BusinessCoverageDurationDays {
  THREE_HUNDRED_SIXTY_DAYS = 'THREE_HUNDRED_SIXTY_DAYS',
  SEVEN_HUNDRED_TWENTY_DAYS = 'SEVEN_HUNDRED_TWENTY_DAYS',
}

export const BUSINESS_COVERAGE_DURATION_DAYS_VALUES = Object.values(
  BusinessCoverageDurationDays
);

export const getBusinessCoverageDurationDaysLabel = (
  value: BusinessCoverageDurationDays
) => {
  switch (value) {
    case BusinessCoverageDurationDays.THREE_HUNDRED_SIXTY_DAYS:
      return $localize`360 jours`;
    case BusinessCoverageDurationDays.SEVEN_HUNDRED_TWENTY_DAYS:
      return $localize`720 jours`;
  }
};
